import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const OnsiteRoutes: Route = {
    path: 'onsite',
    data: { title: 'onsite-app' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'users',
        },
        {
            path: 'users',
            loadComponent: () =>
                import('./users/onsite-users.component').then((m) => m.OnsiteUsersComponent),
            data: { title: 'onsite-app-users' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'enterprises',
            loadComponent: () =>
                import('./enterprises/onsite-enterprises.component').then((m) => m.OnsiteEnterprisesComponent),
            data: { title: 'created-enterprises' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'rotations',
            loadComponent: () =>
                import('./rotations/onsite-rotations.component').then((m) => m.OnsiteRotationsComponent),
            data: { title: 'created-rotations' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-linking',
            loadComponent: () =>
                import('./contract-linking/contract-linking.component').then((m) => m.ContractLinkingComponent),
            data: { title: 'contract-linking' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'survey-readiness',
            loadComponent: () =>
                import('./survey-readiness/survey-readiness.component').then((m) => m.SurveyReadinessComponent),
            data: { title: 'survey-readiness' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
    ],
};
